import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'BBI' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'BBI', label: 'Bull and Bear Index', pane: 'main', params: [3, 6, 12, 24], outputs: ['bbi'] })
